<div class="manage-job-profiles-page scroll-container" ref="manageTrustType">
  <div class="job-profiles-card card">
    <div class="job-profiles-card-header">
      <div class="job-profiles-title-group">
        <button
          v-if="should_show_programme_back_button"
          type="button"
          class="job-profiles-programme-back-btn"
          @click="go_back_to_programme"
        >
          <i class="bi bi-arrow-left" aria-hidden="true"></i>
          <span>{{ programme_back_label }}</span>
        </button>
        <h2 class="job-profiles-card-title">
          <i class="bi bi-file-earmark-text me-2"></i>
          Job Profiles
        </h2>
      </div>
      <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow py-1 create-job-profile-btn" data-bs-toggle="modal" data-bs-target="#create_trust_type">
        <i class="bi bi-plus-lg me-1"></i>
        Create Job Profile
      </button>
    </div>
    <div class="card-body job-profiles-card-body">
      <div v-if="active_tab === 'Job Profiles'" class="job-profiles-table-wrap">
        <ManageJobProfilesList
          :table_key="`jobs-${table_render_key}`"
          :headers="trust_types_headers"
          :rows="table_safe_trust_types"
          @view-row="view_job_description"
        />
      </div>
    </div>
  </div>
</div>

<teleport to="body">
<div class="modal fade" id="assign_main_job_sub_programs_modal" tabindex="-1" aria-labelledby="assign_main_job_sub_programs_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="assign_main_job_sub_programs_label">Assign Job to Sub Programmes</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div v-if="assign_job_modal_sub_programs.length" class="d-grid gap-2">
          <div v-for="sp in assign_job_modal_sub_programs" :key="sp.id" class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              :id="`job-sp-${sp.id}`"
              :value="sp.id"
              v-model="assign_job_modal_selected_sub_program_ids"
            >
            <label class="form-check-label text-xxs" :for="`job-sp-${sp.id}`">
              {{ sp.name }}
            </label>
          </div>
        </div>
        <div v-else class="text-center py-2">
          <p class="text-muted text-xxs mb-0">No sub-programs available for this project.</p>
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="save_main_job_sub_program_assignments">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<teleport to="body">
<div
  class="modal fade job-profile-side-modal"
  id="view_job_profile_modal"
  tabindex="-1"
  aria-labelledby="view_job_profile_label"
  aria-hidden="true"
>
  <div
    class="modal-dialog"
    :class="view_job_profile_drawer_expanded ? 'modal-fullscreen' : 'modal-dialog-scrollable'"
  >
    <div class="modal-content bg-white p-0">
      <div class="modal-body job-profile-side-modal-body">
        <ViewJobProfile
          v-if="view_job_entity_type_id"
          :jobId="view_job_entity_type_id"
          :drawer-mode="true"
          :drawer-expanded="view_job_profile_drawer_expanded"
          :profile-meta="view_job_profile_meta"
          @close-drawer="close_modal('view_job_profile_modal')"
          @toggle-drawer-expand="set_view_job_profile_drawer_expanded"
          @edit-profile="open_drawer_job_edit_modal"
          @new-advert="open_selected_job_advert_modal"
          @manage-advert="open_drawer_advert_edit_modal"
          @view-applicants="redirect_drawer_advert_applicants"
          @view-all-applicants="redirect_drawer_profile_applicants"
        />
      </div>
    </div>
  </div>
</div>
</teleport>

<CreateAdvertModal
  :headers="headers"
  :entityTypeId="selected_row.id"
  :entityTypeName="selected_row.entity_type"
  :openNonce="create_advert_open_nonce"
  @advert-created="on_advert_created"
  @advert-error="on_advert_error"
/>

<EditAdvertModal
  :headers="headers"
  :selectedAdvert="selected_advert"
  :openNonce="edit_advert_open_nonce"
  @advert-updated="on_advert_updated"
  @advert-error="on_advert_error"
/>

<teleport to="body">
<div class="modal fade" id="archive_job_profile_modal" tabindex="-1" aria-labelledby="archive_job_profile_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="archive_job_profile_label">Delete Job Profile</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p class="text-xs mb-1 fw-bold">
          Are you sure you want to delete "{{ archive_job_profile_name || 'this job profile' }}"?
        </p>
        <p class="text-muted text-xxs mb-0">This will remove it from the active Job Profiles list.</p>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-outline-secondary btn-sm text-xxs" data-bs-dismiss="modal">
          Cancel
        </button>
        <button type="button" class="btn btn-outline-danger btn-sm text-xxs delete-job-profile-confirm-btn" :disabled="archive_job_profile_loading" @click="archive_job_profile">
          <span v-if="archive_job_profile_loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          Delete
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>


<teleport to="body">
<div class="modal fade" id="assign_sub_entity_modal" tabindex="-1" aria-labelledby="assign_sub_entity_modal_label" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 rounded-3">

        <!-- Modal Header -->
        <div class="modal-header cute-header d-flex align-items-center justify-content-between px-4 py-3 border-0 rounded-top-3">
          <h5 class="modal-title text-white text-xxs fw-bold mb-0" id="assign_sub_entity_modal_label">Assign Sub-Entity Type</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body p-4 bg-light">
          <!-- Section Title -->
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div>
              <label class="form-label text-xxs fw-semibold me-2 mb-0">
                Assign Sub-Entity Type to:
              </label>
              <span class="fw-bold text-dark text-xxs">
                {{ current_form.parent_name }}
              </span>
            </div>
            <span class="badge bg-secondary rounded-pill text-xxs">
              {{ available_children.length }} Available
            </span>
          </div>


          <!-- DataTable -->
          <div  class="table-responsive">
            <table class="table table-bordered table-hover align-middle" id="assign_sub_entity_table" :key="'assign-table-' + datatable_key">
              <thead class="custom-header">
                <tr class="text-x">
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">No</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Sub-Entity Name</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Status</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Assign</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(child_item, index) in available_children" :key="child_item.id" class="text-xxs">
                  <!-- Counter -->
                  <td class="text-xxs text-start">{{ index + 1 }}</td>
                  <!-- Sub-Entity Name -->
                  <td class="text-xxs text-start">{{ child_item.entity_type_name }}</td>

                  <!-- Status -->
                  <td>
                    <span class="badge"
                          :class="{ 'bg-success': child_item.is_assigned, 'bg-secondary': !child_item.is_assigned }">
                      {{ child_item.is_assigned ? 'Assigned' : 'Unassigned' }}
                    </span>
                  </td>

                  <td class="text-center">
                    <div class="form-check form-switch d-flex justify-content-center">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        :id="'toggle-' + child_item.id"
                        :checked="child_item.is_assigned"
                        :disabled="child_item.is_loading"
                        @change="on_toggle_assign(child_item, $event)"
                      >
                    </div>
                  </td>
                </tr>
              </tbody>

            </table>
          </div>
        </div>

    </div>
  </div>
</div>
</teleport>

<!-- Create Trust Type Modal - Multi-Stage -->
<teleport to="body">
<div class="modal fade" id="create_trust_type" tabindex="-1" aria-labelledby="create_trust_type_label" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      
      <!-- Stage 1: Create (Initial Form) -->
      <div v-if="create_modal_stage === 'create'">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs" id="create_project_label">Create Job Profile</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="modal-form-group form-group mb-3">
            <label for="trust_type_name" class="modal-form-label form-label text-xxs">Job Profile:</label>
            <input type="text" v-model="trust_type_name" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" placeholder="Enter Job Profile Name Here">
          </div>
          <div class="modal-form-group form-group mb-3">
            <label for="trust_type_description" class="modal-form-label form-label text-xxs">Description:</label>
            <textarea type="text" v-model="trust_type_description" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" placeholder="Enter Job Profile Description Here" rows="4" cols="10"></textarea>
          </div>
          <div class="modal-form-group form-group mb-3">
            <label class="modal-form-label form-label text-xxs">Requirements:</label>
            <textarea v-model="create_job_requirements" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" placeholder="Enter Job Profile Requirements Here" rows="4" cols="10"></textarea>
          </div>
          <div class="modal-form-group form-group mb-3">
            <label class="modal-form-label form-label text-xxs">Key Duties:</label>
            <textarea v-model="create_job_key_duties" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" placeholder="Enter Job Profile Key Duties Here" rows="4" cols="10"></textarea>
          </div>
          <div class="modal-form-group form-group mb-3">
            <label class="modal-form-label form-label text-xxs">Upload Job Profile Document (PDF):</label>
            <input type="file" accept="application/pdf" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" @change="on_job_file_selected">
            <small class="text-muted text-xxs">Attach a PDF, click Extract with AI, review sections, then Save.</small>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-3 gap-2">
            <button type="button" class="btn btn-primary-dark btn-sm px-3 shadow text-xxs" @click="create_trust_type">
              Save Job Profile
            </button>
            <button type="button" class="btn btn-primary-dark btn-sm px-3 shadow text-xxs" :disabled="is_extracting_ai || !job_profile_file" @click="extract_with_ai">
              <span v-if="!is_extracting_ai">
                Extract with AI
              </span>
              <span v-else>
                <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span> Extracting...
              </span>
            </button>
          </div>
        </div>
      </div>

      <!-- Stage 2: Extracting (Progress) -->
      <div v-if="create_modal_stage === 'extracting'" class="extracting-stage d-flex flex-column align-items-center justify-content-center">
        <div class="extracting-spinner mb-3"></div>
        <h5 class="extracting-title mb-1 text-center">Extracting Job Information</h5>
        <p class="extracting-subtitle mb-4 text-center">AI is analysing your document ({{ job_profile_file?.name }} · {{ (job_profile_file?.size / 1024 / 1024).toFixed(2) }} MB)</p>
        
        <div class="progress-list">
          <div v-for="(step, idx) in extraction_progress_steps" :key="idx"
            class="progress-step mb-1"
            :class="{
              'progress-step-done': step.status === 'done',
              'progress-step-running': step.status === 'running',
              'progress-step-wait': step.status === 'wait'
            }">
            <div class="step-icon"
              :class="{
                'step-icon-done': step.status === 'done',
                'step-icon-running': step.status === 'running',
                'step-icon-wait': step.status !== 'done' && step.status !== 'running'
              }">
              <span v-if="step.status === 'done'">✓</span>
              <span v-else-if="step.status === 'running'">⟳</span>
              <span v-else>·</span>
            </div>
            <span>{{ step.label }}</span>
          </div>
        </div>
      </div>

      <!-- Stage 3: Extracted (Edit Sections) -->
      <div v-if="create_modal_stage === 'extracted'">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs" id="create_project_label">Create Job Profile</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="modal-form-group form-group mb-3">
            <label class="modal-form-label form-label text-xxs">Job Title</label>
            <input type="text" v-model="create_job_title" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm">
          </div>
          <div class="modal-form-group form-group mb-3">
            <label class="modal-form-label form-label text-xxs">Description</label>
            <input type="text" v-model="create_job_description" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm">
          </div>

          <div v-if="has_extraction_preview || create_job_sections.length" class="extraction-panel mb-3">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <div>
                <p class="extraction-panel-header mb-1"><i class="fas fa-check-circle me-1"></i>Extraction Complete!</p>
                <small class="extraction-panel-count">{{ create_job_sections.length }} sections found</small>
              </div>
            </div>

            <div class="sections-grid mb-3">
              <div class="extraction-preview-sidebar section-sidebar border rounded-3 p-3 bg-light">
                <div class="d-flex gap-2 mb-3">
                  <input type="text" v-model="create_new_section_title" class="form-control form-control-sm text-xxs" placeholder="New section">
                  <button type="button" class="btn btn-sm btn-dark text-xxs text-nowrap" @click="add_create_section">
                    <i class="fas fa-plus me-1"></i>Add
                  </button>
                </div>
                
                <div v-for="(section, index) in create_job_sections" :key="index" @click="set_active_create_section(index)"
                  class="section-card mb-1"
                  :class="{ 'section-card-active': index === create_active_section_index }">
                  <div class="d-flex justify-content-between">
                    <div>
                      <p class="section-card-label">Section {{ index + 1 }}</p>
                      <p class="section-card-title">{{ section.title || 'Untitled' }}</p>
                    </div>
                    <button type="button" class="btn btn-sm btn-remove-inline" @click.stop="remove_create_section(index)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                  <div class="d-flex gap-1 mt-1">
                    <span class="section-entry-badge">{{ (section.descriptions || []).length }} entries</span>
                  </div>
                </div>
              </div>

              <div class="section-editor border rounded-3 p-3 bg-white">
                <div v-if="active_create_section">
                  <label class="form-label text-xxs text-uppercase fw-bold mb-2">Section Title</label>
                  <input type="text" v-model="active_create_section.title" class="form-control form-control-sm text-xxs mb-3">
                  
                  <div class="show-advert-toggle d-flex align-items-center justify-content-between mb-3">
                    <div>
                      <p class="show-advert-label">Show on Advert</p>
                      <small class="show-advert-hint">Toggle visibility</small>
                    </div>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" v-model="active_create_section.show_on_advert">
                    </div>
                  </div>

                  <label class="form-label text-xxs text-uppercase fw-bold mb-2">Description(s)</label>
                  <div v-for="(desc, idx) in active_create_section.descriptions" :key="idx" class="d-flex gap-2 mb-2">
                    <textarea v-model="active_create_section.descriptions[idx]" class="form-control text-xxs" rows="2"></textarea>
                    <button type="button" class="btn btn-sm btn-remove-inline" @click="remove_create_description_entry(create_active_section_index, idx)" :disabled="active_create_section.descriptions.length === 1">
                      <i class="fa fa-minus"></i>
                    </button>
                  </div>
                  <button type="button" class="btn btn-outline-primary btn-sm text-xxs w-100" @click="add_create_description_entry(create_active_section_index)">
                    <i class="fas fa-plus me-1"></i>Add Description
                  </button>
                </div>
                <div v-else class="empty-editor-state text-center py-4">
                  <p class="mb-0">Nothing selected</p>
                  <small>Choose a section on the left</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0 p-2 d-flex justify-content-between">
          <button type="button" class="btn btn-outline-secondary btn-sm px-3 text-xxs" @click="go_to_create_stage('create')">Back</button>
          <button type="button" class="btn btn-primary-dark btn-sm px-3 shadow text-xxs" @click="create_trust_type">Save Job Profile</button>
        </div>
      </div>

    </div>
  </div>
</div>
</teleport>

<!-- Edit Trust Type Modal -->
<teleport to="body">
<div class="modal fade" id="edit_trust_type" tabindex="-1" aria-labelledby="edit_trust_type_label" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="edit_entity_type_label">Edit Job Profile</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body p-3 p-md-4">
        <ViewJobProfile
          v-if="edit_trust_type_id"
          :jobId="edit_trust_type_id"
          initial-mode="edit"
          :embedded-edit-modal="true"
          @profile-saved="on_job_profile_saved"
          @cancel-edit="close_modal('edit_trust_type')"
        />
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Job Preview Modal Component -->

<job_preview_modal
  :parsed_document="parsed_document"
  :parsed_job_id="parsed_job_id"
  :parsed_raw_text="parsed_raw_text"
  :parsed_active_section="parsed_active_section"
  :parsed_responsibility_index="parsed_responsibility_index"
  :parsed_save_state="parsed_save_state"
  :parsed_save_message="parsed_save_message"
  :parsed_editor_mode="parsed_editor_mode"
  :parsed_history="parsed_history"
  :parsed_history_index="parsed_history_index"
  :parsed_sections="parsed_sections"
  :parsed_completion_percent="parsed_completion_percent"
  :parsed_is_ready="parsed_is_ready"
  @update:mode="set_parsed_editor_mode"
  @update:section="set_parsed_section"
  @update:document="(doc) => { parsed_document = doc; mark_parsed_dirty(parsed_active_section); }"
  @undo="undo_parsed_change"
  @redo="redo_parsed_change"
  @export-html="export_parsed_html"
  @export-pdf="export_parsed_pdf"
  @publish="publish_parsed_job"
  @save="save_parsed_section(parsed_active_section)"
  @check-content="section_has_content"
/>
